import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicRankingHorizontalBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'number', required: true },
    { field: 'y', type: 'string', required: true },
    { field: 'group', type: 'date', required: true }
  ],
  businessRules: [
    {
      name: 'dynamic-ranking-horizontal-bar-sufficient-data',
      validator: data => data.length > 1,
      message: 'Dynamic ranking horizontal bar chart requires more than 1 data point',
      suggestion: 'Provide multiple data points for meaningful ranking visualization',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-horizontal-bar-x-diversity',
      validator: (data, layer) => {
        const { encoding } = layer;
        const xValues = new Set(data.map(item => item[encoding?.x as string]));
        return xValues.size > 1;
      },
      message: 'Dynamic ranking chart requires diverse x-field values',
      suggestion: 'Provide different numerical values in the x field for ranking comparison',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-horizontal-bar-sufficient-categories',
      validator: (data, layer) => {
        const { encoding } = layer;
        const yValues = new Set(data.map(item => item[encoding?.y as string]));
        return yValues.size > 3;
      },
      message: 'Dynamic ranking horizontal bar chart requires more than 3 categories',
      suggestion: 'Provide at least 4 different categories in the y field for effective ranking',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-horizontal-bar-time-series',
      validator: (data, layer) => {
        const { encoding } = layer;
        const groupValues = new Set(data.map(item => item[encoding?.group as string]));
        return groupValues.size > 1;
      },
      message: 'Dynamic ranking chart requires multiple time points for animation',
      suggestion: 'Provide at least 2 different time points in the group field for dynamic effect',
      severity: 'error'
    },
    {
      name: 'dynamic-ranking-horizontal-bar-optimal-time-points',
      validator: (data, layer) => {
        const { encoding } = layer;
        const groupValues = new Set(data.map(item => item[encoding?.group as string]));
        return groupValues.size >= 3 && groupValues.size <= 50;
      },
      message: 'Dynamic ranking chart works best with 3-50 time points',
      suggestion: 'Consider providing 3-50 time points for optimal animation performance',
      severity: 'warning'
    }
  ]
};
